<template>
  <div
    :id="`accordion-${id}`"
    class="accordion accordion-flush"
  >
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-1-${id}`"
          aria-expanded="true"
          aria-controls="flush-collapseOne"
        >
          {{ capitalizeFirstLetter($tc('words.generalInformations')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-1-${id}`"
        class="accordion-collapse collapse show"
      >
        <div class="accordion-body">
          <ResourceMetaData
            :is-main="isMain"
            :form-config="formConfig"
            :meta-data="metaData"
            @set="setMetaData"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isMain && mainResourceGeographicLayer"
      class="accordion-item"
    >
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-2-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseTwo"
        >
          {{ capitalizeFirstLetter($tc('words.geographicalLayer')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-2-${id}`"
        class="accordion-collapse collapse"
      >
        <div class="accordion-body">
          <ResourceGeographicalLayer
            :key="`resource-geographical-layer-form-${mainResourceGeographicLayer.codename}`"
            :form-config="formConfig"
            :geo-data="geoData"
            :codename-disabled="true"
            :is-x-y="isXY"
            @set="setGeoData"
          />
        </div>
      </div>
    </div>
    <!-- <MapsWC
      v-if="isMain && mainResourceGeographicLayer"
      :id="id"
    /> -->
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-3-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseThree"
        >
          {{ capitalizeFirstLetter($tc('words.dataSchema')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-3-${id}`"
        class="accordion-collapse collapse"
      >
        <div class="accordion-body">
          <ResourceDataSchema
            :key="`${isMain ? 'resource' : 'annexe'}-data-schema`"
            :schema-data="schemaData"
            @set="setSchemaData"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isWMSStyleAvailable && isMain && mainResourceGeographicLayer"
      class="accordion-item"
    >
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-4-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseFour"
          @click="$refs.WMSComponent.setActiveStyle()"
        >
          <div>
            <div style="width: 100%;">
              {{ $t('resource.accordion.style.label') }}
            </div>
            <div style="font-size: 0.85rem; color: #747c84; font-style: italic; margin-top: .5rem;">
              {{ $t('resource.accordion.style.help') }}
            </div>
          </div>
        </button>
      </h2>
      <div
        :id="`flush-collapse-4-${id}`"
        class="accordion-collapse collapse"
      >
        <div
          class="accordion-body"
          :style="{
            padding: 0
          }"
        >
          <ResourceWMSStyle ref="WMSComponent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import {
  resourceAPI,
  geospatialAPI
 } from '@/api';
import { ErrorService } from '@/services/error-service.js';

import {
  ResourceDataSchema,
  ResourceGeographicalLayer,
  ResourceMetaData
} from '@/app/resource/components';
import ResourceWMSStyle from '@/components/Resource/ResourceWMSStyle.vue';

const MAPS_WC_AVAILABLE = process.env.VUE_APP_MAPS_WC_AVAILABLE === 'true';

export default {
  name: 'ResourceAccordion',

  components: {
    ResourceDataSchema,
    ResourceGeographicalLayer,
    ResourceMetaData,
    ResourceWMSStyle
  },

  props: {
    id: {
      type: Number,
      default: 1
    },
    isMain: {
      type: Boolean,
      default: true
    },
    formConfig: {
      type: Object,
      default: () => {}
    },
    metaResource: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      metaData: {
        displayName: null,
        description: null,
        kind: null,
        lastUpdateDate: null
      },
      geoData: {
        geographiclayerDisplayName: null,
        // geographiclayerCodename: null,
        columnX: null,
        columnY: null,
        crs: null
      },
      schemaData: {
        schemaIdentifier: null,
        schemaVersion: null,
        schemaFormat: null
      },
      isWMSStyleAvailable: MAPS_WC_AVAILABLE
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset'
    ]),
    ...mapState('resources', [
      'mainResource',
      'mainResourceGeoData',
      'resourceKinds'
    ]),
    ...mapGetters('resources', [
      'mainResourceGeographicLayer'
    ]),

    isXY() {
      return false;
    },

    isMetaDataChanged() {
      return this.metaData.displayName !== this.metaResource.display_name ||
        this.metaData.description !== this.metaResource.description ||
        this.metaData.lastUpdateDate !== this.metaResource.last_update_date ||
        (this.metaResource.kind && this.metaData.kind !== this.resourceKinds.find(el => el.id === this.metaResource.kind.id)) ||
        (!this.metaResource.kind && this.metaData.kind);
    },
    isGeoDataChanged() {
      return this.mainResourceGeoData &&
        this.geoData.geographiclayerDisplayName !== this.mainResourceGeoData.display_name;
    },
    isSchemaDataChanged() {
      if (
        this.metaResource.extras &&
        this.metaResource.extras.length > 0 &&
        this.metaResource.extras.find(el => el.key === 'schema_identifier')
      ) {
        return this.schemaData.schemaIdentifier !== this.metaResource.extras.find(el => el.key === 'schema_identifier') ||
          this.schemaData.schemaVersion !== this.metaResource.extras.find(el => el.key === 'schema_version') ||
          this.schemaData.schemaFormat !== this.metaResource.extras.find(el => el.key === 'schema_format');
      } else {
        return this.schemaData.schemaIdentifier !== null ||
          this.schemaData.schemaVersion !== null ||
          this.schemaData.schemaFormat !== null;
      }
    }
  },

  watch: {
    metaResource: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.initForms();
        }
      }
    },

    mainResourceGeographicLayer: {
      deep: true,
      async handler(newValue) {
        // refresh data
        if (newValue && newValue['@uri']) {
          this.loadMainRessource();
        }
      }
    }
  },

  created() {
    this.$root.$on('updateResourceInfos', () => {
      this.updateResourceInfos();
    });

    this.initForms();
  },

  beforeRouteLeave(to, from, next) {
    const webcomponent = document.getElementById('webcomponent');
    const mapComponent = webcomponent.vueComponent;
    if (mapComponent && this.mainResourceGeoData && this.mainResourceGeoData.layerName) {
      mapComponent.removeLayerFromMap(this.mainResourceGeoData.layerName);
    }
    next();
  },

  methods: {
    ...mapMutations('resources', [
      'SET_MAIN_RESOURCE_GEO_DATA'
    ]),
    ...mapActions('resources', [
      'PATCH_RESOURCE'
    ]),

    async initForms() {
      try {
        if (this.metaResource) {
          this.metaData.displayName = this.metaResource.display_name;
          this.metaData.description = this.metaResource.description;
          if (this.metaResource.kind) {
            this.metaData.kind = this.resourceKinds.find(el => el.id === this.metaResource.kind.id);
          }
          this.metaData.lastUpdateDate = this.metaResource.last_update_date;
          if (
            this.metaResource.extras &&
            this.metaResource.extras.find(el => el.key === 'schema_identifier') &&
            this.metaResource.extras.find(el => el.key === 'schema_version') &&
            this.metaResource.extras.find(el => el.key === 'schema_format')
          ) {
            this.schemaData.schemaIdentifier = this.metaResource.extras.find(el => el.key === 'schema_identifier').value;
            this.schemaData.schemaVersion = this.metaResource.extras.find(el => el.key === 'schema_version').value;
            this.schemaData.schemaFormat = this.metaResource.extras.find(el => el.key === 'schema_format').value;
          }
        }
        if (
          this.mainResourceGeographicLayer &&
            (!this.mainResourceGeoData ||
              this.mainResourceGeoData.id !== this.mainResourceGeographicLayer.id
            )
        ) {
          this.$emit('loading', true);
          this.loadMainRessource();
         
          this.$emit('loading', false);
        } else if (this.mainResourceGeoData) {
          this.geoData.geographiclayerDisplayName = this.mainResourceGeoData.display_name;
          // this.geoData.geographiclayerCodename = this.mainResourceGeoData.codename;
          this.geoData.columnX = this.mainResourceGeoData.column_x ? this.mainResourceGeoData.column_x : null;
          this.geoData.columnY = this.mainResourceGeoData.column_y ? this.mainResourceGeoData.column_y : null;
          this.geoData.crs = this.mainResourceGeoData.crs ? this.mainResourceGeoData.crs : null;
        }
      } catch (err) {
        console.error(err);
      }
    },

    async loadMainRessource(){
      const response = await resourceAPI.getResourceData(this.mainResourceGeographicLayer['@uri']);
      if (response) {
        response.layerName=response.codename;//default value
        if(response.rel && response.rel[0] && response.rel[0]['@class']=='restlayer'){
          const restlayer = await resourceAPI.getResourceData(response.rel[0]['@uri']);
          const realLayerName=restlayer.name;
          
          //TODO in core add workspace in restlayer instead of parsing geoserver_ows_url
          const owsurl=restlayer.geoserver_ows_url;
          const workspaceName=owsurl.substring(owsurl.indexOf('geoserv/')+8,owsurl.indexOf('/ows'));
          response.workspace=workspaceName;
          response.layerName=workspaceName+':'+realLayerName;
        }
        this.SET_MAIN_RESOURCE_GEO_DATA(response);
        this.geoData.geographiclayerDisplayName = response.display_name;
        // this.geoData.geographiclayerCodename = response.codename;
        this.geoData.columnX = response.column_x ? response.column_x : null;
        this.geoData.columnY = response.column_y ? response.column_y : null;
        this.geoData.crs = response.crs ? response.crs : null;
      }
    },

    setMetaData(e) {
      this.metaData = { ...e.form };
    },
    setGeoData(e) {
      this.geoData = { ...e.form };
    },
    setSchemaData(e) {
      this.schemaData = { ...e.form };
    },

    async updateResourceInfos() {
      try {
        if (this.isMetaDataChanged || this.isSchemaDataChanged) {
          this.$emit('loading', true);
          await this.PATCH_RESOURCE({
            id: this.metaResource.id,
            data: {
              display_name: this.metaData.displayName,
              description: this.metaData.description,
              ...(this.metaData.kind && this.metaData.kind.id) && {
                kind_id: this.metaData.kind.id
              },
              last_update_date: this.metaData.lastUpdateDate,
              ...this.schemaData.schemaIdentifier && {
                extras: [
                  {
                    key: 'schema_identifier',
                    value: this.schemaData.schemaIdentifier
                  },
                  {
                    key: 'schema_version',
                    value: this.schemaData.schemaVersion
                  },
                  {
                    key: 'schema_format',
                    value: this.schemaData.schemaFormat
                  }
                ]
              },
            },
            datasetId: this.currentDataset.id,
          });
        }
        if (this.mainResourceGeographicLayer && this.isGeoDataChanged) {
          this.$emit('loading', true);
          // retrieve scenarios
          const scenarios = await geospatialAPI.getResourceGeographicLayerScenarios(this.mainResourceGeographicLayer.id);

          // then patch geographic layer
          await resourceAPI.patchResourceGeographicLayer(
            this.mainResourceGeographicLayer['@uri'],
            { display_name: this.geoData.geographiclayerDisplayName },
          );

          // finally run scenario
          if (scenarios && scenarios.length) {
            const scenarioId = scenarios[0].id;
            await geospatialAPI.runResourceGeographicLayerScenario(this.mainResourceGeographicLayer.id, scenarioId);
          }

          // refresh data
          const response = await resourceAPI.getResourceData(this.mainResourceGeographicLayer['@uri']);
          if (response) {
            this.SET_MAIN_RESOURCE_GEO_DATA(response);
            this.geoData.geographiclayerDisplayName = response.display_name;
            // this.geoData.geographiclayerCodename = response.codename;
          }
        }
        this.$emit('loading', false);
      } catch (err) {
        console.error(err);
        ErrorService.onError(err);
        this.$emit('loading', false);
      }
    },
  }
};
</script>

<style lang="less">
.accordion-button:not(.collapsed) {
  color: inherit;
}
.accordion-header {
  .accordion-button {
    font-weight: 700 !important;
    background-color: #0074cc16 !important;
  }
  .accordion-button:not(.collapsed) {
    color: inherit;
  }
}
.accordion-body {
  padding-left: 5px;
  background-color: #eff3f52d;
}
</style>